import React, { Component } from 'react';
import { translate } from "react-i18next";
import { ListGroup, Row, Col, Button } from 'react-bootstrap';
import { getDatesDisplayValue } from '../../backend/UIUtils';



class AlarmInfoList extends Component {

  constructor(props) {
    super(props);
    this.select = this.select.bind(this);
  }

 select (id){
   this.props.loadById(id);
 }


  render() {
    const { t } = this.props;
    return (
      <div>
        
        <ListGroup >
          {this.props.warnings.map((w) => {
            return (
              <ListGroup.Item key={w.id} variant={w.cssClass ? w.cssClass : 'light'}>
                <Row >
                  <Col lg={1} xs={1}>{w.active ? t('yes') : t('no')}</Col>
                  <Col lg={1} xs={1}>{t(w.lang)}</Col>
                  <Col lg={4} xs={4}>{w.title}</Col>
                  <Col lg={4} xs={5}>{getDatesDisplayValue(w.startDate, w.endDate, false, 'de')}</Col>
                  <Col lg={1} xs={1}>
                    <Button variant="outline-primary" onClick={() => this.select(w.id)} className="float-right"><span className="fa fa-edit"></span></Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            )
          })}
        </ListGroup>
       
       
      </div>
    )
  }

}

export default translate("translations")(AlarmInfoList);

